<pf-content>
    <section pfSection pfTitle="Recent Changes (Last 2 Weeks)">
        @if (availableFieldOptions.length) {
            <div class="field-filter">
                <pf-select
                    [multiple]="true"
                    [data]="availableFieldOptions"
                    [control]="changeFilterControl"
                    [tagAmount]="3"
                    placeholder="Filter by changed field..."
                    (selectedMultiple)="onFieldFilterChange($event)">
                </pf-select>
            </div>
        }
        @if (filteredChanges$ | async; as changes) {
            @if (changes.length === 0) {
                <pf-text type="description" class="no-changes-message"
                    >No changes recorded in the last 2 weeks.
                </pf-text>
            } @else {
                <nz-timeline>
                    @for (
                        change of changes;
                        track trackByFn($index, change);
                        let first = $first
                    ) {
                        <nz-timeline-item [nzLabel]="changeLabelTmpl">
                            <ng-template #changeLabelTmpl>
                                <div class="timeline-label">
                                    <pf-text>{{ change.userEmail }}</pf-text>
                                    <pf-text type="description"
                                        >{{ change.createdDate | PfDate }}
                                    </pf-text>
                                </div>
                            </ng-template>
                            <platform-change-view
                                [autoExpand]="first"
                                [entityName]="entityName"
                                [customValueTransformer]="
                                    facade.customValueFormatter
                                "
                                [excludedFields]="facade.excludedFields"
                                [entityChange]="change"></platform-change-view>
                        </nz-timeline-item>
                    }
                </nz-timeline>
            }
        }
        <pf-button buttonType="submit" block (click)="openDetailedHistory()"
            >View Detailed History
        </pf-button>
    </section>
</pf-content>
